module.exports = __webpack_public_path__ + "static/media/qining.91e271ff.jpg";